$( function(){
  
  //   faq dropdown
  $('.faq-dropdown-item').click(function(event) {
    $(this).toggleClass('close');
    $(this).toggleClass('open');
    $(this).find('i.fa').toggleClass('fa-plus');
    $(this).find('i.fa').toggleClass('fa-minus');
  });

  //   sidebar dropdown
  $('.sidebar-dropdown-item').click(function(event) {
    $(this).toggleClass('close');
    $(this).toggleClass('open');
    $(this).find('i.fa').toggleClass('fa-plus');
    $(this).find('i.fa').toggleClass('fa-minus');
  });
  
  var timer = setInterval(function(){
    if( $(".dev_stockStatus").length > 0 ){
      var arr = $('.dev_stockStatus').text().split(':');
      $('.dev_stockStatus').html('<span>' + arr[0] + '.</span>' + arr[1] );
      clearInterval(timer);
    }
  }, 1);
  
  $('.selection-wrapper .single-option-radio label').on('click', function(){
    setTimeout( function(){
      
      var vId    = document.URL.split('?variant=')[1];
      var devQty = $("[data-id="+vId+"]").attr('data-variantQuantity');
      
      if( devQty > 0 && devQty < 11 ){
        $('.devVariantQtyLft').text( devQty );
        $('.devRemainingItems').show();
      } else {
        $('.devRemainingItems').hide();
      }
      
    },200);
  });
  
});